import { useState, useEffect } from 'react';
import { User, onAuthStateChanged, signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../services/firebase';

const useAuth = () => {
    const [user, setUser] = useState<User | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    const login = async (email: string, password: string) => {
        return await signInWithEmailAndPassword(auth, email, password);
    };

    const logout = async () => {
        return await auth.signOut();
    };

    return { user, loading, login, logout };
};

export default useAuth;